import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Newspaper, ExternalLink, Calendar, Building2 } from 'lucide-react';

const newsArticles = [
  {
    id: 9,
    title: "Competency-Based Examinations: Revolutionizing Aesthetic Medicine Practitioner Assessment for Real-World Skills",
    publication: "Oneindia",
    date: "July 6, 2026",
    summary: "The growing focus on practitioner competency in aesthetic medicine has led to increased interest in examination models that assess clinical ability alongside theoretical understanding. Unlike traditional certification systems that may rely primarily on course attendance, competency-based examinations are designed to evaluate whether a practitioner can demonstrate the skills required in real clinical settings.",
    url: "https://www.oneindia.com/information/competency-based-examinations-aesthetic-medicine-practitioner-skills-012-8138299.html",
    image: "https://imagesvs.oneindia.com/img/2026/07/competency-based-examinations-1783321941883-600x340.jpg"
  },
  {
    id: 8,
    title: "As Aesthetic Medicine Expands, the Push for Common Training Standards Gains Momentum",
    publication: "India.com",
    date: "June 24, 2026",
    summary: "As aesthetic medicine grows worldwide, industry leaders are increasingly advocating for standardized training, certification, and safety protocols to ensure quality patient care. Academies, assessment bodies, and quality assurance organisations have started exploring collaborative approaches aimed at improving transparency and standardisation.",
    url: "https://www.india.com/money/as-aesthetic-medicine-expands-the-push-for-common-training-standards-gains-momentum-8455664/",
    image: "https://static.india.com/wp-content/uploads/2026/06/medio.jpg?impolicy=Medium_Widthonly&w=700"
  },
  {
    id: 7,
    title: "Why Are Healthcare Labels Losing Trust? The Industry Faces a New Test",
    publication: "Zee News",
    date: "May 24, 2026",
    summary: "Healthcare and wellness products are being judged by real-world performance, not only by one-time certifications. As formulas and research evolve faster, regulators and companies are turning to continuous monitoring, data analysis and post-market validation systems. The International Medical Competency Accreditation Council has been involved in efforts exploring models that combine traditional certification with clinical evaluation and ongoing data analysis.",
    url: "https://zeenews.india.com/health/why-are-healthcare-labels-losing-trust-the-industry-faces-a-new-test-3049934.html",
    image: "https://english.cdn.zeenews.com/sites/default/files/2026/05/24/1946746-healthcare-product-validation.jpg?im=Resize=(400)"
  },
  {
    id: 6,
    title: "Complication Awareness and Ethical Practice Gain Focus as Aesthetic Medicine Expands",
    publication: "Free Press Journal",
    date: "April 7, 2026",
    summary: "The rapid expansion of aesthetic medicine is bringing renewed attention to complication management and ethical clinical practice. As procedures become more widely available, medical professionals and educators are emphasising safety, informed consent, and practitioner accountability. Competency-based education models are gaining attention to address gaps in training quality.",
    url: "https://www.freepressjournal.in/latest-news/complication-awareness-and-ethical-practice-gain-focus-as-aesthetic-medicine-expands",
    image: "https://media.assettype.com/freepressjournal/2026-04-07/yd60bhoa/Copy-of-Copy-of-Copy-of-Copy-of-Copy-of-Copy-of-Copy-of-Queen-Of-All-Mayhem-2026-04-07T163707.016.jpg?width=1200"
  },
  {
    id: 5,
    title: "Boom in Medical Training Programs Raises Questions Over Quality and Consistency",
    publication: "The Financial Express",
    date: "April 1, 2026",
    summary: "The rapid growth of medical science and the rising need for specialised skills have led to a boom in private training programs across healthcare fields worldwide. Unlike formal medical education, which follows a structured system, many post-qualification courses run independently, raising questions about quality and consistency. Organisations such as IMCAC have been working with training providers to align programs with measurable competency standards.",
    url: "https://www.financialexpress.com/jobs-career/education-boom-in-medical-training-programs-raises-questions-over-quality-and-consistency-4190936/",
    image: "https://images.financialexpressdigital.com/2026/03/Financial-express-2026-03-31T223807.613.jpg?w=1600"
  },
  {
    id: 4,
    title: "Clinical Progression Matrix Signals Push for Structured Training in Aesthetic Medicine",
    publication: "DNA India",
    date: "March 20, 2026",
    summary: "IMCAC's Clinical Progression Matrix introduces a structured, competency-based framework to standardize global aesthetic medicine training, prioritizing patient safety and professional accountability. The framework maps competencies such as patient evaluation, procedural planning, technical skills, complication management, and ethical practice across different levels of experience.",
    url: "https://www.dnaindia.com/insights/report-clinical-progression-matrix-signals-push-for-structured-training-in-aesthetic-medicine-3203740",
    image: "https://cdn.dnaindia.com/sites/default/files/2026/03/20/2743847-dnayrani.jpg"
  },
  {
    id: 1,
    title: "Global Experts Call For Higher Safety Standards In Cosmetic Practice",
    publication: "ABP Live",
    date: "March 3, 2026",
    summary: "International physicians meet in Thailand to address complication risks and promote accountability in aesthetic procedures. The congress was led by the International Medical Competency Accreditation Council under the Global Aesthetic Safety Initiative.",
    url: "https://news.abplive.com/infotainment/global-experts-call-for-higher-safety-standards-in-cosmetic-practice-1829607",
    image: "https://feeds.abplive.com/onecms/images/uploaded-images/2026/03/03/2e86a6b490fcf1375846e41c095e767a1772525719630401_original.jpg?impolicy=abp_cdn&imwidth=1200&height=675"
  },
  {
    id: 2,
    title: "The Global Shift from Attendance-Based to Competency-Based Certification in Aesthetic Medicine",
    publication: "News24",
    date: "February 18, 2026",
    summary: "Aesthetic medicine training is shifting from attendance-based certifications to competency-focused models as procedures grow more complex and standards evolve. The article highlights how organizations like IMCAC have introduced assessment-led certification systems designed to verify competence across multiple domains of practice.",
    url: "https://news24online.com/information/the-global-shift-from-attendance-based-to-competency-based-certification-in-aesthetic-medicine/751693/",
    image: "https://news24online.com/wp-content/uploads/2026/02/news-24-2-11.png"
  },
  {
    id: 3,
    title: "Why Competency-Based Medical Education Is Gaining Ground in Aesthetic Medicine",
    publication: "Amar Ujala",
    date: "February 20, 2026",
    summary: "Competency-based medical education is gaining traction in aesthetic medicine, shifting focus from attendance-based certification to measurable clinical skills. The article discusses how IMCAC has introduced competency-based assessment systems and curriculum design models intended to verify clinical proficiency.",
    url: "https://english.amarujaladigital.com/business/bonus/why-competency-based-medical-education-is-gaining-ground-in-aesthetic-medicine",
    image: "https://staticimg.amarujala.com/assets/images/english.amarujaladigital.com/2026/02/20/gasi_72e33936e832db1bca7d16f7a5075d7e.jpeg"
  }
];

export default function NewsMediaPage() {
  return (
    <div className="bg-white min-h-screen" data-testid="news-media-page">
      {/* Hero Section */}
      <section className="py-16 bg-[#1B2A4A]">
        <div className="imcac-container">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/10 rounded-sm mb-6">
            <Newspaper className="h-4 w-4 text-[#C5A572]" />
            <span className="text-xs font-semibold tracking-wider text-white uppercase">Press Coverage</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white font-heading mb-4">
            News & Media
          </h1>
          <div className="h-1 w-20 bg-[#C5A572] mb-4" />
          <p className="text-lg text-slate-300 max-w-2xl">
            Recent news coverage and media mentions featuring IMCAC's contributions.
          </p>
        </div>
      </section>

      {/* News Articles Section */}
      <section className="py-12">
        <div className="imcac-container max-w-5xl">
          <h2 className="text-2xl font-bold text-[#1B2A4A] font-heading mb-8">Recent Coverage</h2>
          
          <div className="space-y-6">
            {newsArticles.map((article) => (
              <Card key={article.id} className="overflow-hidden hover:shadow-lg transition-shadow">
                <CardContent className="p-0">
                  <div className="flex flex-col md:flex-row">
                    {/* Article Image */}
                    <div className="md:w-1/3 h-48 md:h-auto">
                      <img 
                        src={article.image} 
                        alt={article.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    
                    {/* Article Content */}
                    <div className="md:w-2/3 p-6">
                      <div className="flex flex-wrap items-center gap-3 mb-3">
                        <Badge className="bg-[#1B2A4A] text-white rounded-sm">
                          <Building2 className="h-3 w-3 mr-1" />
                          {article.publication}
                        </Badge>
                        <span className="text-sm text-slate-500 flex items-center gap-1">
                          <Calendar className="h-3 w-3" />
                          {article.date}
                        </span>
                      </div>
                      
                      <h3 className="text-xl font-bold text-[#1B2A4A] font-heading mb-3 leading-tight">
                        {article.title}
                      </h3>
                      
                      <p className="text-slate-600 text-sm mb-4 line-clamp-3">
                        {article.summary}
                      </p>
                      
                      <Button 
                        variant="outline"
                        className="rounded-sm border-[#C5A572] text-[#C5A572] hover:bg-[#C5A572] hover:text-white"
                        onClick={() => window.open(article.url, '_blank')}
                      >
                        Read Full Article <ExternalLink className="h-4 w-4 ml-2" />
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
